import React from "react";
import { Box, Paper, Typography, LinearProgress } from "@mui/material";
import SpeedIcon from "@mui/icons-material/Speed";

export default function DailyLimitsWidget({ data }) {
  if (!data) return null;
  const { tier, dailyLimit, usedToday, remaining, usagePercent } = data;

  return (
    <Paper className="glass-card" sx={{ p: 3 }}>
      <Typography fontWeight={700} fontSize={15} color="#1e293b" mb={2}>Daily Limits</Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
        <SpeedIcon sx={{ fontSize: 32, color: usagePercent > 80 ? "#ef4444" : "#6366f1" }} />
        <Box>
          <Typography fontWeight={800} fontSize={24} color="#1e293b">{usedToday}/{dailyLimit}</Typography>
          <Typography variant="caption" color="#64748b">messages sent today</Typography>
        </Box>
      </Box>
      <LinearProgress variant="determinate" value={usagePercent} sx={{ height: 8, borderRadius: 4, bgcolor: "#e2e8f0", mb: 1, "& .MuiLinearProgress-bar": { bgcolor: usagePercent > 80 ? "#ef4444" : usagePercent > 50 ? "#f59e0b" : "#22c55e", borderRadius: 4 } }} />
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="caption" color="#64748b">{usagePercent}% used</Typography>
        <Typography variant="caption" color={remaining > 0 ? "#22c55e" : "#ef4444"} fontWeight={600}>{remaining} remaining</Typography>
      </Box>
      {dailyLimit < 999999 && (
        <Box sx={{ mt: 1.5, p: 1.5, borderRadius: 2, bgcolor: "rgba(245,158,11,0.06)", border: "1px solid #fde68a" }}>
          <Typography variant="body2" color="#92400e" fontWeight={600} fontSize={12}>
            Warm-up active: Tier {tier} · Limit {dailyLimit}/day
          </Typography>
        </Box>
      )}
    </Paper>
  );
}
